<template>
    <div>
        <sav-responsive-access-template logo="https://disticloudfiles.net/img/savinfo/logo/casino.png">
            <div v-if="screenWidth >= 992">
                <div class="container p-12 mx-auto sm:px-4">
                    <div class="flex flex-wrap">
                        <div class="w-1/4 pr-5 text-left">
                            <div class="sticky">
                                <div class="pt-4">
                                    <side-menu />
                                </div>
                            </div>
                        </div>
                        <div class="w-3/4 pt-4 pl-4">
                            <img src="https://disticloudfiles.net/img/savinfo/logo/casino.png" class="h-20 mx-auto mb-4">

                            <slot></slot>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="screenWidth <= 992">
                <div
                class="p-6 pt-4 bg-gray-100"
                style="min-height: 100vh !important; width: 100vw !important;"
                >
                    <div class="mt-2">
                        <img src="https://disticloudfiles.net/img/savinfo/logo/casino.png" class="block w-3/4 mx-auto my-4">

                        <button
                        v-show="backButton"
                        class="inline-block px-3 py-1 mb-3 font-normal leading-normal text-center text-blue-700 no-underline whitespace-no-wrap align-middle bg-transparent border rounded select-none"
                        @click="$router.go(-1)">
                            <h1 class="mb-0 mr-2 text-gray-900">
                                <i class="fas fa-arrow-left"></i>
                            </h1>
                        </button>
                        <slot></slot>
                        <div class="pb-5 mb-5"></div>
                    </div>
                </div>

                <!-- Mobile navbar -->
                <div class="fixed bottom-0 left-0 right-0 p-2 py-2 bg-white border-t border-gray-200">
                    <div class="flex items-center justify-around">
                        <router-link :to="{ name: 'home'}">
                            <h4 class="mb-0">
                                <i class="fas fa-home"></i>
                            </h4>
                        </router-link>
                        <router-link :to="{ name: 'form.home'}" class="text-2xl default-text-color">
                            <h4 class="mb-0">
                                <i class="fas fa-plus-circle"></i>
                            </h4>
                        </router-link>
                        <router-link :to="{ name: 'user.update'}">
                            <h4 class="mb-0">
                                <i class="fas fa-user"></i>
                            </h4>
                        </router-link>
                    </div>
                </div>
            </div>
        </sav-responsive-access-template>
    </div>
</template>

<script>
import SavResponsiveAccessTemplate from '../../../../components/SavResponsiveAccessTemplate.vue'
import SideMenu from './CasinoSideMenuLargeScreen'
export default {
    props: {
        title: {
            type: String,
            default: "Casino"
        },
        backButton: {
            type: Boolean,
            default: true
        },
        navigationBar: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            screenWidth: 0,
        }
    },
    components: {
        SideMenu,
        SavResponsiveAccessTemplate
    },
    methods: {
        isSelect(routeName) {
            return (this.$route.name.split('.')[0] == routeName) ? true : false
        }
    },
    mounted() {
        this.screenWidth = window.innerWidth
        window.addEventListener('resize', (event) => {
            this.screenWidth = window.innerWidth
        }, true);

        document.title = "Géant Casino - Espace après-vente"

        var style = document.createElement("style")
        style.textContent = `
            .default-bg-color {background: #006e31 !important;}
            .default-text-color {color: #006e31 !important;}
            .default-bg-color-hover:hover {background: #000 !important;}
            .default-text-inside-color {color: #fff !important;}
        `
        document.head.appendChild(style)
    }
}
</script>



// WEBPACK FOOTER //
// src/companies/casino/views/template/SavTemplate.vue